import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { FilterButtonComponent } from 'src/app/components/filter-button/filter-button.component';

import { DatetimePickerModule } from '../components/datetime-picker/datetime-picker.module';
import { RecipientInputModule } from '../components/recipient-input/recipient-input.module';
import { SlackBlocksModule } from '../components/slack-blocks/slack-blocks.module';

import { SlackMessagePageRoutingModule } from './slack-message-routing.module';
import { SlackMessagePage } from './slack-message.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    IonicModule,
    SlackMessagePageRoutingModule,
    NgxTippyModule,
    SlackBlocksModule,
    DatetimePickerModule,
    RecipientInputModule,
    NgxDatatableModule,
    FilterButtonComponent,
  ],
  declarations: [SlackMessagePage],
})
export class SlackMessagePageModule {}
